import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PulseLoader } from 'react-spinners';
import { mergeClassNames } from '../../utils';
const Loader = ({ color, size, className, }) => (_jsx("div", { className: mergeClassNames('flex justify-center', className), children: _jsx(PulseLoader, { color: color, loading: true, size: size }) }));
Loader.defaultProps = {
    color: '#77856e',
    size: 10,
};
Loader.propTypes = {
    color: PropTypes.string,
    size: PropTypes.number,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
};
export default Loader;
